/* import __COLOCATED_TEMPLATE__ from './misc-bolt.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default class ActionMore extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "width", 24);
    _defineProperty(this, "height", 24);
    _defineProperty(this, "viewBox", '0 0 24 24');
    _defineProperty(this, "defaultColor", 'black');
  }
}
/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.0001 23.1701V15.0001H3.08008L13.0001 0.830078V9.00008H20.9201L11.0001 23.1701ZM6.92008 13.0001H13.0001V16.8301L17.0801 11.0001H11.0001V7.17008L6.92008 13.0001Z" fill="black" fill-opacity="0.9" />
</svg> */